<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <form class="kt-form w-webkit-fill-available" [formGroup]="form">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ data.mode === 'create' ? 'Create' : 'Edit' }} Payment Mode</h5>
        <span class="modal-x-button" (click)="onCloseDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      <div class="modal-body">
        <!-- Payment Processors & Weightage -->
        <div class="row mt-3">
          <div class="col-12">
            <section class="card">
              <div class="card-header d-flex justify-content-between align-items-center">
                <span>Payment Processors List</span>
                <button type="button" class="btn btn-brand btn-sm" (click)="addProcessor()"><i class="fa fa-plus"></i> Add</button>
              </div>
              <section class="col-12 p-3" formArrayName="payment_processors">
                <div class="row mb-3" *ngFor="let processor of payment_processors.controls; let i = index" [formGroupName]="i">
                  <div class="col-lg-6 form-group mb-0 pr-0 adjust-border">
                    <label class="control-label"> Payment Processor <span class="text-danger">*</span></label>
                    <angular2-multiselect [data]="getAvailableProcessors(i)" [settings]="processorDropdownSettings" formControlName="payment_processor_id">
                    </angular2-multiselect>
                    <small class="form-text text-muted" *ngIf="getSelectedProcessor(i) as selected">
                      <ng-container *ngIf="selected.min_deposit !== null || selected.max_deposit !== null; else noLimits">
                        Min Deposit: {{ selected.min_deposit === null ? '-' : (selected.min_deposit | number: '1.2-2') }} /
                        Max Deposit: {{ selected.max_deposit === null ? '-' : (+selected.max_deposit === 0 ? 'Unlimited' : (selected.max_deposit | number: '1.2-2')) }}
                      </ng-container>
                      <ng-template #noLimits>No deposit limits configured</ng-template>
                    </small>
                  </div>
                  <div class="col-lg-4 form-group mb-0 pl-0 pr-0 adjust-border">
                    <label class="control-label"> Weightage <span class="text-danger">*</span></label>
                    <input type="number" formControlName="weightage" class="form-control" min="1" max="100" (keypress)="onNumberOnly($event)" (input)="onCheckWeightage($event, i)">
                  </div>
                  <div class="col-lg-2 form-group mb-0 pl-0 adjust-border">
                    <label class="control-label invisible" aria-hidden="true">&nbsp;</label>
                    <button type="button" class="btn btn-danger btn-sm w-100 remove-button" (click)="removeProcessor(i)" [ngClass]="payment_processors.length > 1 ? '' : 'disabled'">
                      <i class="fa fa-trash"></i> Remove
                    </button>
                  </div>
                </div>
              </section>
            </section>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-6 form-group">
            <label class="control-label"> Name <span class="text-danger">*</span></label>
            <fieldset [disabled]="data.mode === 'edit' ? true : false">
              <input type="text" formControlName="name" class="form-control">
            </fieldset>
          </div>
          <div class="col-lg-6 form-group">
            <label class="control-label"> Currency <span class="text-danger">*</span></label>
            <angular2-multiselect [data]="dropdown.currencies" [settings]="currencyDropdownSettings" formControlName="settings_currency_ids">
            </angular2-multiselect>
          </div>
          <div class="col-lg-6 form-group">
            <label class="control-label"> Field Type <span class="text-danger">*</span></label>
            <select formControlName="deposit_field_type" class="form-control">
              <option [value]="null" [disabled]="true">Please Select</option>
              <option *ngFor="let value of fieldTypes" [value]="value.id">{{ value.name }}</option>
            </select>
          </div>
          <div class="col-lg-6 form-group">
            <label class="control-label"> Shortcut Amount </label>
            <input type="text" formControlName="shortcut_amount" class="form-control" placeholder="Example: 100,500,1000" (keypress)="onAmountShortcut($event)">
            <small class="form-text text-muted">Separate multiple amounts with a comma (,)</small>
          </div>
          <div class="col-lg-6 form-group">
            <label class="control-label"> Member Type <span class="text-danger">*</span></label>
            <select formControlName="member_type" class="form-control">
              <option [value]="null" [disabled]="true">Please Select</option>
              <option *ngFor="let value of dropdown.types" [value]="value.id">{{ value.name }}</option>
            </select>
          </div>
          <div class="col-lg-6 form-group">
            <label class="control-label"> Status <span class="text-danger">*</span> </label>
            <select formControlName="status" class="form-control">
              <option *ngFor="let value of dropdown.statuses; let i = index;" [value]="i">{{ value }}</option>
            </select>
          </div>
        </div>

        <div class="row mt-3">
          <!-- Desktop -->
          <div class="col-lg-6 form-group">
            <section class="card">
              <div class="card-header">Desktop Image</div>
              <section class="col-12 p-3">
                <div class="border row p-0 m-0">
                  <div class="col-12 p-3">
                    <label class="btn btn-default btn-sm float-left">
                      <span>Choose file</span>
                      <input type="file" hidden accept="image/*" (change)="onUploadFile($event, 'desktop')" [disabled]="(mobileLoading || desktopLoading)">
                    </label>
                    <div class="spinner-wrapper row ml-5" *ngIf="desktopLoading">
                      <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
                    </div>
                    <div class="image-wrapper mt-2" *ngIf="form.get('desktop_image').value">
                      <img class="img-fluid w-100" alt="Desktop Image" [src]="form.get('desktop_image').value" />
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </div>
          <!-- Mobile -->
          <div class="col-lg-6 form-group">
            <section class="card">
              <div class="card-header">Mobile Image</div>
              <section class="col-12 p-3">
                <div class="border row p-0 m-0">
                  <div class="col-12 p-3">
                    <label class="btn btn-default btn-sm float-left">
                      <span>Choose file</span>
                      <input type="file" hidden accept="image/*" (change)="onUploadFile($event, 'mobile')" [disabled]="(mobileLoading || desktopLoading)">
                    </label>
                    <div class="spinner-wrapper row ml-5" *ngIf="mobileLoading">
                      <mat-progress-spinner mode="indeterminate" diameter="25"></mat-progress-spinner>
                    </div>
                    <div class="image-wrapper mt-2" *ngIf="form.get('mobile_image').value">
                      <img class="img-fluid w-100" alt="Mobile Image" [src]="form.get('mobile_image').value" />
                    </div>
                  </div>
                </div>
              </section>
            </section>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-tab-group animationDuration="0ms" class="form-group mb-0 mat-tab-header-pagination-controls-enabled" formGroupName="locales" *ngIf="dropdown.locales.length > 0">
              <mat-tab *ngFor="let value of dropdown.locales; let i = index" [formGroupName]="value.id">
                <ng-template mat-tab-label>
                  <span class="mat-tab">{{ value.code | uppercase }}</span>
                </ng-template>
                <div class="row p-3">
                  <div class="col-lg-6 form-group">
                    <label class="control-label"> Display Name </label>
                    <input type="text" formControlName="display_name" class="form-control">
                  </div>
                  <div class="col-lg-6 form-group">
                    <label class="control-label"> Position </label>
                    <input type="number" formControlName="position" class="form-control">
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
        <kt-submit-button [isDisabled]="!form.valid" [buttonLoading]="buttonLoading" (confirmed)="onSave()"></kt-submit-button>
      </div>
    </div>
  </form>
</div>

<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog($event)"></kt-swal-alert>